export enum DeviceConfigurationStatus {
  DRAFT = 'draft',
  REPORTED = 'reported',
  DESIRED = 'desired',
  UNKNOWN = 'unknown',
  OVERRIDE = 'override'
}
